import React from 'react';

import {
  SkeletonBody,
  SkeletonImage,
  SkeletonButton,
} from '@xingternal/skeleton';

import styles from './Skeleton.css';

type CropSkeletonProps = {
  isCover?: boolean;
};
const CropSkeleton = ({ isCover }: CropSkeletonProps) => (
  <div className={styles.skeletonWrapper}>
    {isCover && (
      <SkeletonBody
        amountRows={3}
        className={styles.description}
        size="small"
        variant="primary"
      />
    )}
    <SkeletonImage variant="primary" className={styles.image} />
    <div className={styles.publishWrapper}>
      <SkeletonButton
        variant="primary"
        size="small"
        className={styles.publish}
      />
    </div>
  </div>
);

export default CropSkeleton;
